module.exports = __webpack_public_path__ + "img/carrierboard1.f3a3089f.png";